var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"icon",attrs:{"color":_vm.isActiveRoute ? 'red' : null,"size":"40"}},[_vm._v(_vm._s(_vm.icon))]),_c('p',{class:{ active: _vm.isActiveRoute }},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }